import { combineReducers } from 'redux';
import isLoading from './is-loading/isLoading.reducer';
import transports from './transports/transports.reducer';
import error from './error/error.reducer';
export default combineReducers({
  error,
  isLoading,
  transports,
});
